import { Flex, Modal } from "antd";
import { FC } from "react";

import BaseButton from "@/components/BaseButton";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

interface DataConfirmModalProps {
    onClose: () => void;
    onClickBack: () => void;
    infoText?: string;
    backTextButton?: string;
}

export const DataConfirmModal: FC<DataConfirmModalProps> = ({
    onClose,
    onClickBack,
    infoText = "Введені дані не будуть збережені. Ви впевнені, що хочете повернутися назад?",
    backTextButton = "Повернутися назад",
}) => {
    return (
        <Modal
            title=""
            open
            onOk={onClose}
            onCancel={onClose}
            centered
            footer={[]}
        >
            <PrimaryText
                fontSize={16}
                lineHeight="20px"
                fontWeight="400"
                padding="0 0 16px 0"
                textAlign="center"
            >
                Ви впевнені?
            </PrimaryText>
            <SecondaryText
                fontSize={14}
                lineHeight="16px"
                fontWeight="400"
                padding="0 0 16px 0"
                textAlign="center"
            >
                {infoText}
            </SecondaryText>

            <Flex vertical gap={8}>
                <BaseButton type="primary" onClick={onClose} bgColor="success">
                    Залишитися
                </BaseButton>

                <BaseButton type="default" onClick={onClickBack}>
                    {backTextButton}
                </BaseButton>
            </Flex>
        </Modal>
    );
};
